import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, viewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, FormService, GridComponent, GridService, NotificationService } from '../../../../tms-shared';
import { UserRole } from '../../models';
import { UserService } from '../../services';

@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrl: './user-roles.component.scss',
  imports: [GridComponent, AsyncPipe],
})
export class UserRolesComponent extends BaseComponent implements OnInit {
  private readonly userService = inject(UserService);
  private readonly gridService = inject(GridService);
  private readonly formService = inject(FormService);
  private readonly notificationService = inject(NotificationService);
  private readonly route = inject(ActivatedRoute);

  private readonly grid = viewChild(GridComponent);

  protected columnDefs: ColDef[] = [
    ...this.gridService.checkboxRowSelect('name', $localize`Name`),
    this.gridService.text('description', $localize`Description`),
  ];

  protected rowData$: Observable<UserRole[]>;

  private userId: string;

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  private getModel() {
    this.rowData$ = this.userService.getUserRoles(this.userId);
    this.grid()?.resetEdited();
  }

  save() {
    if (this.grid().edited) {
      this.formService.beginSave();
      this.userService
        .updateUserRoles(this.userId, this.grid().selectedIds)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.notificationService.saveSuccess($localize`User Roles`);
            this.getModel();
            this.formService.endSave(false);
          },
          error: () => {
            this.notificationService.saveFail($localize`User Roles`);
            this.formService.endSave(true);
          },
        });
    }
  }
}
